(() => {
  if (customElements.get('ff-mix-match')) return;
  class ForgeMixMatch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = [...this.querySelectorAll('[data-ffmm-card]')];
      this.quantities = this.cards.map(() => 0);
      this.addButton = this.querySelector('[data-ffmm-add]');
      this.error = this.querySelector('[data-ffmm-error]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP' });
      this.price = Number(this.dataset.price);
      this.wrapper = this.closest('.shopify-section');
      this.originalPlace = document.createComment('Forge Mix & Match original placement');
      this.wrapper.before(this.originalPlace);
      this.media = matchMedia('(max-width:749px)');
      this.handleClick = event => {
        const card = event.target.closest('[data-ffmm-card]');
        const index = this.cards.indexOf(card);
        if (this.busy) return;
        if (event.target.closest('[data-ffmm-one]')) {
          if (this.cards.every(c => Number(c.dataset.max) > 0)) this.quantities = this.cards.map(() => 1);
        } else if (index >= 0 && event.target.closest('[data-ffmm-plus]') && this.total() < 3 && this.quantities[index] < Number(card.dataset.max)) this.quantities[index]++;
        else if (index >= 0 && event.target.closest('[data-ffmm-minus]')) this.quantities[index] = Math.max(0, this.quantities[index] - 1);
        else if (event.target.closest('[data-ffmm-add]')) { this.submit(); return; }
        this.render();
      };
      this.addEventListener('click', this.handleClick);
      this.refresh = () => { this.place(); this.detect(); this.chat(); };
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.chat(); });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.refresh, { passive: true });
      this.media.addEventListener('change', this.refresh);
      this.observer = new MutationObserver(() => { if (!this.busy && !this.failed) this.detect(); });
      this.observer.observe(this.querySelector('.ffmm__native'), { childList: true, subtree: true });
      this.render();
      this.refresh();
      this.readyTimer = setTimeout(() => { if (!this.ready && !this.failed) this.fallback(); }, 20000);
    }
    disconnectedCallback() {
      // Moving a complete section on mobile briefly disconnects it.
      if (this.isConnected) return;
      clearTimeout(this.readyTimer);
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.refresh);
      this.media?.removeEventListener('change', this.refresh);
      this.initialized = false;
      this.removeEventListener('click', this.handleClick);
      document.documentElement.classList.remove('ffmm-chat-clearance');
    }
    place() {
      const hero = document.querySelector('.ff-mobile .ff-hero');
      if (this.media.matches && this.dataset.mobilePlacement === 'true' && hero) {
        if (hero.nextElementSibling !== this.wrapper) hero.after(this.wrapper);
      } else if (this.originalPlace.isConnected && this.originalPlace.nextSibling !== this.wrapper) this.originalPlace.after(this.wrapper);
    }
    widget() { return this.querySelector(`[id="rbr-bundle-${CSS.escape(this.dataset.offer)}"]`); }
    nativeSelectors() {
      const widget = this.widget();
      if (!widget) return [];
      return this.cards.map(card => {
        const link = [...widget.querySelectorAll('a[href]')].find(a => {
          try { return new URL(a.href).pathname === `/products/${card.dataset.handle}`; } catch { return false; }
        });
        return link?.closest('[class*="style_productContainer_"]')?.querySelector('[class*="variantSelector_container"]');
      });
    }
    nativePrice() {
      const text = this.widget()?.querySelector('[class*="cartInfoPrices_finalPrice_"]')?.textContent;
      if (!text) return NaN;
      // Current UK offer renders a GBP decimal subtotal; other locales fail safely.
      return Math.round(Number(text.replace(/[^\d.]/g, '')) * 100);
    }
    detect() {
      const controls = this.nativeSelectors();
      const valid = this.cards.length === 3 && this.cards.every(c => c.dataset.variant && c.dataset.handle) && controls.length === 3 && controls.every(Boolean) && this.price > 0 && this.dataset.currency === 'GBP' && Boolean(this.widget()?.querySelector('.rbr-addBundleBtn-container'));
      if (valid && !this.ready) {
        if (this.nativePrice() !== 0) { this.fallback(); return; }
        this.ready = true;
        this.classList.add('is-ready');
        clearTimeout(this.readyTimer);
        // Keep native handlers intact but hide duplicate controls from tab order.
        this.querySelector('.ffmm__native').setAttribute('inert', '');
        this.render();
      }
    }
    total() { return this.quantities.reduce((a, b) => a + b, 0); }
    render() {
      const total = this.total();
      this.cards.forEach((card, i) => {
        card.querySelector('[data-ffmm-qty]').textContent = this.quantities[i];
        card.querySelector('[data-ffmm-minus]').disabled = !this.ready || this.busy || !this.quantities[i];
        card.querySelector('[data-ffmm-plus]').disabled = !this.ready || this.busy || total >= 3 || this.quantities[i] >= Number(card.dataset.max);
      });
      this.querySelector('[data-ffmm-one]').disabled = !this.ready || this.busy || !this.cards.every(c => Number(c.dataset.max) > 0);
      this.querySelector('[data-ffmm-count]').textContent = `${total} / 3`;
      this.querySelector('[data-ffmm-status]').textContent = total === 3 ? this.dataset.ready : this.dataset.remaining.replace('[count]', 3 - total);
      this.querySelector('[data-ffmm-fill]').style.width = `${total / 3 * 100}%`;
      this.addButton.disabled = !this.ready || this.busy || total !== 3;
      this.addButton.textContent = this.busy ? this.dataset.loading : total === 3 ? `${this.dataset.add} · ${this.money.format(this.price / 100)}` : this.dataset.incomplete;
    }
    async submit() {
      if (this.busy || !this.ready || this.total() !== 3) return;
      this.busy = true;
      this.render();
      try {
        if (this.nativePrice() !== 0) throw new Error('Native selection is not empty');
        // Remove inert only for the app's own event processing, not for user input.
        this.querySelector('.ffmm__native').removeAttribute('inert');
        for (let i = 0; i < this.cards.length; i++) {
          for (let n = 0; n < this.quantities[i]; n++) {
            const control = this.nativeSelectors()[i];
            if (!control || control.dataset.disabled === 'true') throw new Error('Rub unavailable');
            control.click();
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          }
        }
        if (this.nativePrice() !== this.price) throw new Error('Offer subtotal mismatch');
        const button = this.widget()?.querySelector('.rbr-addBundleBtn-container');
        if (!button || button.getAttribute('aria-disabled') === 'true') throw new Error('Offer unavailable');
        // Remember the merchant-bound offer for this cart only. Cart edits can
        // otherwise invalidate the app's exact selected combination even when
        // three eligible rubs remain. Storage failure must not block purchase.
        try {
          const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' }).then(r => r.json());
          sessionStorage.setItem('ff-mix-match-intent', JSON.stringify({
            token: cart.token,
            offer: Number(this.dataset.offer),
            uuid: this.dataset.offerUuid,
            variants: this.cards.map(card => Number(card.dataset.variant)),
            price: this.price,
            expires: Date.now() + 86400000,
          }));
        } catch { /* Native app flow remains available without session storage. */ }
        button.click();
        // Fast Bundle owns cart registration/discount/navigation. Never duplicate its API call.
        this.submitTimer = setTimeout(() => {
          if (this.isConnected) {
            if (this.nativePrice() === 0) {
              this.quantities = this.cards.map(() => 0);
              this.busy = false;
              this.querySelector('.ffmm__native').setAttribute('inert', '');
              this.render();
            } else this.fallback();
          }
        }, 15000);
      } catch { this.fallback(); }
    }
    fallback() {
      this.failed = true;
      this.ready = false;
      this.busy = false;
      this.classList.remove('is-ready');
      this.classList.add('is-fallback');
      this.querySelector('.ffmm__native').removeAttribute('inert');
      this.error.textContent = this.dataset.error;
      this.error.hidden = false;
      this.addButton.disabled = true;
      this.observer?.disconnect();
      clearTimeout(this.readyTimer);
      clearTimeout(this.submitTimer);
    }
    chat() {
      const html = document.documentElement;
      const host = document.querySelector('shopify-chat');
      const runtime = host?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
      const launcher = runtime?.querySelector('[part="activator"]');
      const dialog = runtime?.querySelector('[part="dialog"]');
      let offset = 0;
      if (this.media.matches && launcher?.getClientRects().length && !dialog?.getClientRects().length && !document.body.classList.contains('overflow-hidden')) {
        const old = Number.parseFloat(html.style.getPropertyValue('--ffmm-chat-offset')) || 0;
        const r = launcher.getBoundingClientRect();
        const base = { left: r.left, right: r.right, top: r.top + old, bottom: r.bottom + old };
        const regions = [...this.querySelectorAll('button:not(:disabled),.ffmm__quantity,.ffmm__add,.ffmm__fallback')].filter(x => x.getClientRects().length).map(x => x.getBoundingClientRect()).filter(x => x.bottom > 0 && x.top < innerHeight && x.left < base.right && x.right > base.left);
        for (let i = 0; i <= regions.length; i++) {
          const collisions = regions.filter(x => base.bottom - offset > x.top - 12 && base.top - offset < x.bottom + 12);
          if (!collisions.length) break;
          const next = Math.max(...collisions.map(x => base.bottom - x.top + 12));
          if (next <= offset) break;
          offset = next;
        }
        offset = Math.ceil(Math.max(0, Math.min(offset, base.top - 8)));
      }
      html.style.setProperty('--ffmm-chat-offset', `${offset}px`);
      html.classList.toggle('ffmm-chat-clearance', offset > 0);
    }
  }
  customElements.define('ff-mix-match', ForgeMixMatch);
})();
